(() => {
  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const one = (selector, root = document) => root.querySelector(selector);

  function fieldValue(form, name) {
    const field = form.elements.namedItem(name);
    if (!field) return '';
    if (typeof field.value === 'string') return field.value.trim();
    return '';
  }

  function escapeHtml(value) {
    return String(value || 'Not specified').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
    })[character]);
  }

  function displayDate(value) {
    if (!value) return 'Not specified';
    const parts = value.split('-').map(Number);
    if (parts.length !== 3) return value;
    return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
      .format(new Date(parts[0], parts[1] - 1, parts[2]));
  }

  function buildSummary(form) {
    return [
      'POTIFY3D CUSTOM COSPLAY ENQUIRY', '',
      'THE BUILD',
      `Project type: ${fieldValue(form, 'project_type') || 'Not specified'}`,
      `Character / source: ${fieldValue(form, 'character') || 'Not specified'}`,
      `Specific piece: ${fieldValue(form, 'piece') || 'Not specified'}`,
      `3D files: ${fieldValue(form, 'files') || 'Not specified'}`,
      `Reference link: ${fieldValue(form, 'reference') || 'Not provided'}`, '',
      'SIZE & FINISH',
      `Dimensions: ${fieldValue(form, 'dimensions') || 'Not specified'}`,
      `Wearable fit: ${fieldValue(form, 'fit') || 'Not provided'}`,
      `Finish: ${fieldValue(form, 'finish') || 'Not specified'}`,
      `Primary use: ${fieldValue(form, 'use') || 'Not specified'}`,
      `Assembly / strength: ${fieldValue(form, 'strength') || 'Not provided'}`, '',
      'TIMING & DELIVERY',
      `Needed by: ${displayDate(fieldValue(form, 'deadline'))}`,
      `Flexibility: ${fieldValue(form, 'flexibility') || 'Not specified'}`,
      `Delivery country: ${fieldValue(form, 'country') || 'Not specified'}`,
      `Budget: ${fieldValue(form, 'budget') || 'Not specified'}`, '',
      'CONTACT',
      `Name / handle: ${fieldValue(form, 'contact[name]') || 'Not specified'}`,
      `Email: ${fieldValue(form, 'contact[email]') || 'Not specified'}`,
      `Instagram: ${fieldValue(form, 'instagram') || 'Not provided'}`, '',
      'OTHER NOTES',
      fieldValue(form, 'notes') || 'None provided'
    ].join('\n');
  }

  function renderReview(form) {
    const review = one('[data-potify-review]', form);
    if (!review) return;
    const row = (label, value) => `<div class="potify-quote__review-line"><span>${label}</span><strong>${escapeHtml(value || 'Not specified')}</strong></div>`;
    review.innerHTML = `
      <div class="potify-quote__review-head"><span>Ready to send</span><strong>${escapeHtml(fieldValue(form, 'piece'))}</strong></div>
      <div class="potify-quote__review-grid">
        <div class="potify-quote__review-group"><h4>The build</h4>${row('Type', fieldValue(form, 'project_type'))}${row('Character', fieldValue(form, 'character'))}${row('Files', fieldValue(form, 'files'))}</div>
        <div class="potify-quote__review-group"><h4>Size and finish</h4>${row('Dimensions', fieldValue(form, 'dimensions'))}${row('Finish', fieldValue(form, 'finish'))}${row('Use', fieldValue(form, 'use'))}</div>
        <div class="potify-quote__review-group"><h4>Timing and delivery</h4>${row('Needed by', displayDate(fieldValue(form, 'deadline')))}${row('Flexibility', fieldValue(form, 'flexibility'))}${row('Destination', fieldValue(form, 'country'))}</div>
        <div class="potify-quote__review-group"><h4>Contact</h4>${row('Name', fieldValue(form, 'contact[name]'))}${row('Email', fieldValue(form, 'contact[email]'))}${row('Instagram', fieldValue(form, 'instagram'))}</div>
        <div class="potify-quote__review-group potify-quote__review-notes"><h4>Other notes</h4><p>${escapeHtml(fieldValue(form, 'notes') || 'No extra notes provided.')}</p></div>
      </div>`;
    const summary = one('[data-potify-summary]', form);
    if (summary) summary.value = buildSummary(form);
  }

  function validateStep(form, number) {
    const step = one(`[data-potify-step="${number}"]`, form);
    if (!step) return true;
    let valid = true;
    all('.is-invalid', step).forEach((element) => element.classList.remove('is-invalid'));

    all('input, select, textarea', step).forEach((field) => {
      if (field.type === 'radio') return;
      if (!field.checkValidity()) {
        field.classList.add('is-invalid');
        field.setAttribute('aria-invalid', 'true');
        valid = false;
      }
    });

    const radioNames = [...new Set(all('input[type="radio"][required]', step).map((field) => field.name))];
    radioNames.forEach((name) => {
      if (!fieldValue(form, name)) {
        const first = all('input[type="radio"]', step).find((field) => field.name === name);
        const group = first ? first.closest('[data-required-group]') : null;
        if (group) group.classList.add('is-invalid');
        all('input[type="radio"]', step)
          .filter((field) => field.name === name)
          .forEach((field) => field.setAttribute('aria-invalid', 'true'));
        valid = false;
      }
    });
    return valid;
  }

  function focusFirstInvalid(form, number) {
    const step = one(`[data-potify-step="${number}"]`, form);
    if (!step) return;
    const field = one('input.is-invalid, select.is-invalid, textarea.is-invalid, .is-invalid input', step);
    if (!field) return;
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
    field.focus({ preventScroll: true });
  }

  function initialiseQuote(form) {
    const steps = all('[data-potify-step]', form);
    const next = one('[data-potify-next]', form);
    const submit = one('[data-potify-submit]', form);
    const back = one('[data-potify-back]', form);
    const progress = one('[data-potify-progress]', form);
    const status = one('[data-potify-submit-status]', form);
    if (!steps.length || !next || !submit || !back || !progress || !status) return;
    let current = 1;

    const setStatus = (message = '') => {
      status.textContent = message;
      status.hidden = !message;
    };

    const showStep = (number) => {
      current = number;
      steps.forEach((step) => step.classList.toggle('is-active', Number(step.dataset.potifyStep) === number));
      all('[data-potify-step-nav]', form.closest('.potify-quote')).forEach((item) => {
        const itemNumber = Number(item.dataset.potifyStepNav);
        item.classList.toggle('is-active', itemNumber === number);
        item.classList.toggle('is-complete', itemNumber < number);
      });
      progress.style.width = `${number * 25}%`;
      back.hidden = number === 1;
      next.hidden = number === 4;
      submit.hidden = number !== 4;
      setStatus();
      if (number === 4) renderReview(form);
      if (window.matchMedia('(max-width: 749px)').matches) {
        form.closest('.potify-quote').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    next.addEventListener('click', () => {
      if (validateStep(form, current)) {
        showStep(Math.min(4, current + 1));
      } else {
        setStatus('Please complete the highlighted field before continuing.');
        focusFirstInvalid(form, current);
      }
    });
    back.addEventListener('click', () => showStep(Math.max(1, current - 1)));
    form.addEventListener('input', (event) => {
      event.target.classList.remove('is-invalid');
      event.target.removeAttribute('aria-invalid');
      const group = event.target.closest('[data-required-group]');
      if (group) {
        group.classList.remove('is-invalid');
        all('[aria-invalid="true"]', group).forEach((field) => field.removeAttribute('aria-invalid'));
      }
      setStatus();
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (current !== 4) {
        showStep(4);
        return;
      }

      let invalidStep = 0;
      for (let number = 1; number <= 4; number += 1) {
        if (!validateStep(form, number)) {
          invalidStep = number;
          break;
        }
      }
      if (invalidStep) {
        showStep(invalidStep);
        setStatus('Please check the highlighted field before sending your enquiry.');
        focusFirstInvalid(form, invalidStep);
        return;
      }

      renderReview(form);
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.innerHTML = 'Sending enquiry…';
      setStatus('Sending your enquiry securely through Shopify…');
      HTMLFormElement.prototype.submit.call(form);
    });
    showStep(1);
  }

  function initialiseCosplay(section) {
    all('[data-potify-filter]', section).forEach((button) => {
      button.addEventListener('click', () => {
        const selected = button.dataset.potifyFilter;
        all('[data-potify-filter]', section).forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        all('[data-potify-project]', section).forEach((card) => {
          card.hidden = selected !== 'all' && card.dataset.potifyProject !== selected;
        });
      });
    });
    all('.potify-quote__form', section).forEach(initialiseQuote);
  }

  function initialise() {
    all('[data-potify-cosplay]').forEach(initialiseCosplay);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();

  document.addEventListener('shopify:section:load', (event) => {
    all('[data-potify-cosplay]', event.target).forEach(initialiseCosplay);
  });
})();
